module.exports = __webpack_public_path__ + "static/media/gold.848ca607.svg";